/**
 * PATH: packages/email-hub/src/feature/lib/watchdogClock.ts
 * FILE_ID: EMAILHUB-FEATURE-LIB-WATCHDOGCLOCK-001
 * PURPOSE: Pure across-remount watchdog math for the inbox zero-row spinner.
 * WHY: BUG-2026-06-10-INBOX-PERPETUAL-SKELETON — the watchdog verdict used to
 *      live only in component state, so a reload/remount loop (the X-User-Id
 *      18->19 identity transition) reset the timer every mount and never
 *      tripped, wedging the pane on the skeleton forever. Persisting the
 *      first-armed timestamp and computing elapsed time across remounts fixes
 *      it; this isolates that arithmetic so it can be unit-tested without
 *      rendering the page.
 * FLOW: (armedAt, now, windowMs) -> remaining ms / tripped boolean
 */

/** Milliseconds left before the watchdog should trip. <=0 means "trip now".
 *  ``armedAt`` is the epoch-ms timestamp the spinner FIRST appeared for the
 *  current user (persisted across remounts). */
export function watchdogRemainingMs(
  armedAt: number,
  now: number,
  windowMs: number,
): number {
  if (!Number.isFinite(armedAt) || armedAt <= 0) return windowMs
  return armedAt + windowMs - now
}

/** True when the accumulated elapsed time (across remounts) has reached the
 *  window — i.e. the pane should escalate to the actionable panel instead of
 *  resetting to the skeleton. */
export function watchdogTrippedNow(
  armedAt: number,
  now: number,
  windowMs: number,
): boolean {
  return watchdogRemainingMs(armedAt, now, windowMs) <= 0
}
